// responsive-tables.js
$(document).ready(function() {
    var switched = false;
    var updateTables = function() {
      if (($(window).width() < 767) && !switched ){
        switched = true;
        $("table:not([style])").each(function(i, element) {
          splitTable($(element));
        });
        return true;
      }
      else if (switched && ($(window).width() > 767)) {
        switched = false;
        $("table:not([style])").each(function(i, element) {
          unsplitTable($(element));
        });
      }
    };
     
    updateTables();
    $(window).on("redraw",function(){switched=false;updateTables();}); // An event to listen for
    $(window).on("resize", updateTables);
      
      function splitTable(original)
      {
        original.wrap("<div class='table-wrapper' />");
        original.wrap("<div class='scrollable' />");
      }
      
      function unsplitTable(original) {
        original.unwrap();
        original.unwrap();
      }
  
  });
  
  $(window).on('load resize', function () {
    if ($(this).width() < 767) {
      $('table tfoot').hide();
    } else {
      $('table tfoot').show();
    }  
  });